export const FETCH_ALL_SUBMISSION_REQUEST = 'homeworkDetailReducer/FETCH_ALL_SUBMISSION_REQUEST';
export const FETCH_ALL_SUBMISSION_SUCCESS = "homeworkDetailReducer/FETCH_ALL_SUBMISSION_SUCCESS";
export const FETCH_ALL_SUBMISSION_FAILED = "homeworkDetailReducer/FETCH_ALL_SUBMISSION_FAILED";

export const ADD_SCORE_REQUEST = 'homeworkDetailReducer/ADD_SCORE_REQUEST';
export const ADD_SCORE_SUCCESS = "homeworkDetailReducer/ADD_SCORE_SUCCESS";
export const ADD_SCORE_FAILED = "homeworkDetailReducer/ADD_SCORE_FAILED";
export const ADD_SCORE_RESET = "homeworkDetailReducer/ADD_SCORE_RESET";

